// import Vue from 'vue';
// import VueRouter from 'vue-router';
import { createRouter, createWebHistory } from 'vue-router';
import Calculator from './components/MyCalculator.vue';
import MyResult from './components/MyResult.vue';
import helloPage from './pages/helloPage.vue';
import nfcPage from './pages/nfcPage.vue';
import resetPassword from './pages/resetPassword.vue';


const routes = [
  {
    path: '/',
    redirect: { name: 'resetPassword' }
    // redirect: { name: 'nfcPage' }
  },
  {
    path: '/reset',
    name: 'resetPassword',
    component: resetPassword,
  },
  {
    path: '/nfc',
    name: 'nfcPage',
    component: nfcPage,
  },
  {
    path: '/hello',
    name: 'helloPage',
    component: helloPage,
  },
  {
    path: '/calc',
    name: 'Calculator',
    component: Calculator,
  },
  {
    path: '/result',
    name: 'MyResult',
    component: MyResult,
    props: route => ({ result: route.query.result ? JSON.parse(route.query.result) : null }),
  },
];

// Create a router instance
const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;